export const PROD = 'prod';
export const PRE = 'pre';
export const TEST = 'test';
export const DAILY = 'daily';
export const LOCAL = 'local';
